export default "__VITE_ASSET__CxXoIECj__"